//
// card-stack.js - Optimized for smooth performance
//

const stacks = document.querySelectorAll('.card-stack');

// Throttle function to limit how often scroll calculations run
function throttle(func, delay) {
  let timeoutId;
  let lastExecTime = 0;
  return function (...args) {
    const currentTime = Date.now();
    
    if (currentTime - lastExecTime > delay) {
      func.apply(this, args);
      lastExecTime = currentTime;
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
        lastExecTime = Date.now();
      }, delay - (currentTime - lastExecTime));
    }
  };
}

// RequestAnimationFrame-based smooth animation
function smoothUpdate(callback) {
  let ticking = false;
  
  return function() {
    if (!ticking) {
      requestAnimationFrame(() => {
        callback();
        ticking = false;
      });
      ticking = true;
    }
  };
}

stacks.forEach((stack) => {
  const items = stack.querySelectorAll('.card-stack-item');

  // Cache DOM elements and their properties
  const itemsData = Array.from(items).map(item => ({
    element: item,
    card: item.firstElementChild,
    cardInner: item.firstElementChild?.firstElementChild,
    cachedHeight: null,
    cachedMarginBottom: null
  }));

  // Function to update cached dimensions (only when needed)
  function updateCachedDimensions() {
    itemsData.forEach(itemData => {
      const { element } = itemData;
      itemData.cachedHeight = element.clientHeight;
      itemData.cachedMarginBottom = parseInt(window.getComputedStyle(element).getPropertyValue('margin-bottom'));
    });
  }

  // Optimized animation function
  function updateCardStack() {
    const arr = itemsData.slice().reverse();
    
    arr.reduce((total, itemData, i) => {
      const { element, card, cardInner, cachedHeight, cachedMarginBottom } = itemData;
      
      if (!card || !cardInner) return total;
      
      const height = cachedHeight + cachedMarginBottom;
      const offset = arr[i - 1] ? arr[i - 1].element.offsetTop - element.offsetTop : height;
        const progress = total + (height - offset) / height;

      // Use CSS custom properties for GPU-accelerated animations
      const translate = -1 * progress;
      const opacity = Math.max(0, 1 - 0.2 * progress);
      const scale = Math.max(0.7, 1 - 0.03 * progress);

      // Apply transforms in a single operation to minimize repaints
      card.style.transform = `translateY(calc(-1rem * ${translate})) scale(${scale})`;
      card.style.willChange = 'transform'; // Hint for GPU acceleration
        cardInner.style.opacity = opacity;

        return progress;
      }, 0);
  }

  // Create throttled and smooth versions of our functions
  const throttledDimensionsUpdate = throttle(updateCachedDimensions, 250);
  const smoothStackUpdate = smoothUpdate(updateCardStack);

  // Initial setup
  updateCachedDimensions();
  updateCardStack();

  // Event listeners with optimizations
  window.addEventListener('load', () => {
    updateCachedDimensions();
    updateCardStack();
  });

  window.addEventListener('resize', throttledDimensionsUpdate);
  window.addEventListener('scroll', smoothStackUpdate, { passive: true });
});
